import { ReactNode, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Icon } from 'views/TokenPages/icons'

const Wrap = styled.details`
  border-radius: 18px;
  border: 1px solid rgba(180, 200, 255, 0.16);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.015));
  min-width: 0;
  summary {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 56px;
    padding: 10px 16px;
    cursor: pointer;
    list-style: none;
    border-radius: 18px;
    &::-webkit-details-marker {
      display: none;
    }
    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.primary};
      outline-offset: 2px;
    }
  }
  .t {
    flex: none;
    font-weight: 800;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.text};
  }
  .h {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.textSubtle};
  }
  .chev {
    flex: none;
    display: inline-flex;
    color: ${({ theme }) => theme.colors.textSubtle};
    transition: transform 0.2s ease;
  }
  &[open] .chev {
    transform: rotate(180deg);
  }
  .body {
    padding: 4px 16px 18px;
  }
`

/** A section that is one line until it is tapped: a title, a short hint, a chevron. `openSignal` opens it from outside (a link to #rules). */
export default function Fold({ title, hint, children, openSignal, testId, id }: { title: string; hint?: ReactNode; children: ReactNode; openSignal?: number; testId?: string; id?: string }) {
  const ref = useRef<HTMLDetailsElement>(null)
  useEffect(() => {
    if (openSignal && ref.current) ref.current.open = true
  }, [openSignal])
  return (
    <Wrap ref={ref} data-testid={testId} id={id}>
      <summary>
        <span className="t">{title}</span>
        {hint ? <span className="h">{hint}</span> : <span className="h" />}
        <span className="chev" aria-hidden="true"><Icon name="chevronDown" size={18} /></span>
      </summary>
      <div className="body">{children}</div>
    </Wrap>
  )
}
